var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useKlskDhp, useIsAuthenticated } from '../hooks';
var PrivateRoute = function (_a) {
    var Component = _a.component, componentName = _a.componentName, Rc = _a.redirectComponent, _b = _a.redirectPath, redirectPath = _b === void 0 ? '/' : _b, rest = __rest(_a, ["component", "componentName", "redirectComponent", "redirectPath"]);
    var klsk = useKlskDhp().klsk;
    var isAuthenticated = useIsAuthenticated();
    return (React.createElement(Route, __assign({ key: 0 }, rest, { render: function (props) { return (klsk.indexOf(componentName) == -1 || !isAuthenticated) ?
            (Rc ? React.createElement(Rc, __assign({}, props)) : React.createElement(Redirect, { to: redirectPath }))
            :
                React.createElement(Component, __assign({}, props)); } })));
};
export default PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map